import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IAppNotificationService } from "@saif-reporting/domain/interfaces/services/IAppNotificationService.js";
import type { AppNotificationDto } from "@saif-reporting/domain/dtos/models/AppNotificationDto.js";
import type { Paginated } from "@saif-reporting/domain/dtos/Paginated.js";
import type { AppNotificationQuery, TopNotificationResponse } from "@saif-reporting/domain/dtos/appNotificationDtos.js";

export class AppNotificationService implements IAppNotificationService {
  private readonly api: IApi;

  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async getAll(query: AppNotificationQuery): Promise<Paginated<AppNotificationDto>> {
    return await this.api.$fetch<Paginated<AppNotificationDto>>("/app-notifications", {
      query,
    });
  }

  async getTopNotificationsForUser(): Promise<TopNotificationResponse> {
    return await this.api.$fetch<TopNotificationResponse>("/app-notifications/get-menu-notifications");
  }

  async view(id: number): Promise<AppNotificationDto> {
    return await this.api.$fetch<AppNotificationDto>(`/app-notifications/${id}`);
  }

  async markAllAsRead(): Promise<void> {
    await this.api.$fetch(`/app-notifications/mark-all-as-read`, {
      method: "post",
    });
  }

  async clearAll(): Promise<void> {
    await this.api.$fetch(`/app-notifications/clear-all`, {
      method: "post",
    });
  }
}
